import * as React from "react";

const MOBILE_BREAKPOINT = 768;
const DESKTOP_BREAKPOINT = 1024;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}

/**
 * Returns true when the viewport width is below the Tailwind `lg` breakpoint (1024px).
 * Useful for JS-based layout switching where Tailwind responsive classes alone can lead
 * to both mobile and desktop variants rendering simultaneously during transitions.
 */
export function useIsBelowLg() {
  const [below, setBelow] = React.useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth < DESKTOP_BREAKPOINT;
  });

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${DESKTOP_BREAKPOINT - 1}px)`);
    const onChange = (e: MediaQueryListEvent) => setBelow(e.matches);
    setBelow(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return below;
}
